import { render, staticRenderFns } from "./pluginInstallTip.vue?vue&type=template&id=654eaa54&scoped=true&"
import script from "./pluginInstallTip.vue?vue&type=script&lang=js&"
export * from "./pluginInstallTip.vue?vue&type=script&lang=js&"
import style0 from "./pluginInstallTip.vue?vue&type=style&index=0&id=654eaa54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654eaa54",
  null
  
)

component.options.__file = "pluginInstallTip.vue"
export default component.exports